import { render, staticRenderFns } from "./line-axis.vue?vue&type=template&id=61277a73&scoped=true&"
import script from "./line-axis.vue?vue&type=script&lang=js&"
export * from "./line-axis.vue?vue&type=script&lang=js&"
import style0 from "./line-axis.vue?vue&type=style&index=0&id=61277a73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61277a73",
  null
  
)

export default component.exports